
const Card = ({ name, flags, navigate, population, region, capital }) => {
  return (
    <article
      onClick={navigate}
      className="group w-full max-w-sm mx-auto overflow-hidden rounded-2xl bg-white dark:bg-containerColor shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer hover:-translate-y-1"
    >
      <div className="overflow-hidden">
        <img
          src={flags?.png}
          alt={`${name} flag`}
          className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>

      <div className="px-5 py-6">
        <h3 className="text-lg font-extrabold mb-3">{name}</h3>

        <div className="space-y-1 text-sm">
          <p>
            <span className="font-semibold">Population: </span>
            {population?.toLocaleString()}
          </p>
          <p>
            <span className="font-semibold">Region: </span>
            {region}
          </p>
          <p>
            <span className="font-semibold">Capital: </span>
            {capital || "N/A"}
          </p>
        </div>
      </div>
    </article>
  );
};
export default Card;